import axios from 'axios'
import type {DigitalVosSignatureUrls} from './digitalVosFormTypes'
import {getBearerToken} from './jwtBootstrap'

const API_URL = process.env.REACT_APP_API_URL

function authHeaders(): Record<string, string> {
  const token = getBearerToken()
  return {
    'Content-Type': 'application/json',
    ...(token ? {Authorization: `Bearer ${token}`} : {}),
  }
}

/** Load signature via API proxy (same-origin) → blob URL for display and html2canvas PDF export. */
export async function resolveSignatureDisplayUrl(
  fileUrl: string | null | undefined,
): Promise<string | null> {
  if (!fileUrl?.trim()) return null

  try {
    const response = await axios.post(
      `${API_URL}/Appoinment/vos-signature-image`,
      {fileUrl: fileUrl.trim()},
      {headers: authHeaders(), responseType: 'blob'}
    )
    const blob = response.data as Blob
    if (response.status === 200 && blob?.size > 0) {
      return URL.createObjectURL(blob)
    }
  } catch (e) {
    console.error('Failed to load VOS signature image via API proxy', e)
  }

  return null
}

export function revokeVosSignatureDisplayUrls(urls: DigitalVosSignatureUrls | undefined): void {
  if (!urls) return
  const seen = new Set<string>()
  for (const url of Object.values(urls)) {
    if (url && url.startsWith('blob:') && !seen.has(url)) {
      seen.add(url)
      URL.revokeObjectURL(url)
    }
  }
}

export async function resolveVosSignatureUrls(input: {
  checkInStaffSignUrl?: string | null
  reqSignUrl?: string | null
  bulkApproverSignUrl?: string | null
  terpSignUrl?: string | null
}): Promise<DigitalVosSignatureUrls> {
  const reqUrl =
    input.bulkApproverSignUrl?.trim() || input.reqSignUrl?.trim() || null

  const [checkInStaff, reqResolved, interpreter] = await Promise.all([
    resolveSignatureDisplayUrl(input.checkInStaffSignUrl),
    resolveSignatureDisplayUrl(reqUrl),
    resolveSignatureDisplayUrl(input.terpSignUrl),
  ])

  return {
    checkInStaff,
    checkOut: reqResolved,
    travelStaff: reqResolved,
    interpreter,
  }
}
